/* eslint-disable import/prefer-default-export */
/**
 * Sanitizes and converts numeric values from form inputs to clean numbers.
 * Removes formatting characters (commas, currency symbols, etc.) from string values
 * while preserving digits and decimal points. Returns numbers unchanged.
 * @param value - The numeric value (string from form inputs or number)
 * @returns Clean number (e.g., "1,234.56" → 1234.56, 10024 → 10024)
 */
export const sanitizeNumericString = (value: number | string): number => {
  return typeof value === 'string' // values from form inputs with precision display are strings
    ? Number(
        value
          .replaceAll(/[^\d.]/g, '') // Remove non-digit/non-dot
          .replaceAll(/(\..*?)\./g, '$1') // Remove all but the first dot
      )
    : value;
};
